module.exports = __webpack_public_path__ + "static/media/delayHeader.ea4ac282.svg";